
import * as z from "zod";
import { EventType, EventAudience } from '@/lib/types';
import { EventStatus } from '@/services/eventService';

export const eventFormSchema = z.object({
  eventName: z.string().min(2, {
    message: "Az esemény nevének legalább 2 karakter hosszúnak kell lennie.",
  }),
  description: z.string().optional().default(""),
  startDate: z.date(),
  endDate: z.date(),
  startTime: z.date(),
  endTime: z.date(),
  timeNotSpecified: z.boolean().default(true), // Changed to true by default
  city: z.string().min(2, {
    message: "A város nevének legalább 2 karakter hosszúnak kell lennie.",
  }).optional().or(z.literal('')),
  venueName: z.string().min(2, {
    message: "A helyszín nevének legalább 2 karakter hosszúnak kell lennie.",
  }).optional().or(z.literal('')),
  address: z.string().min(5, {
    message: "A címnek legalább 5 karakter hosszúnak kell lennie.",
  }).optional().or(z.literal('')),
  region: z.string().optional(),
  postalCode: z.string().optional(),
  isOnline: z.boolean().default(false),
  eventUrl: z.string().optional().or(z.literal('')),
  registrationUrl: z.string().optional().or(z.literal('')),
  eventType: z.enum(['conference', 'workshop', 'training', 'webinar', 'meetup', 'seminar', 'networking', 'exhibition', 'congress', 'course', 'symposium'], {
    required_error: "Az esemény típusának megadása kötelező.",
  }),
  creditPoints: z.string().optional(),
  postAccredited: z.boolean().optional().default(false),
  maxAttendees: z.string().optional(),
  imageUrl: z.string().optional(),
  professions: z.array(z.string()).default([]),
  status: z.nativeEnum(EventStatus).default(EventStatus.DRAFT),
}).refine((data) => {
  // Only validate eventUrl if the event is online
  if (data.isOnline) {
    return z.string().url({ message: "Érvényes URL-t adjon meg" }).safeParse(data.eventUrl).success;
  }
  return true;
}, {
  message: "Érvényes URL-t adjon meg az online eseményhez",
  path: ["eventUrl"]
})
  .refine((data) => {
    // Validate date range - end date should be on or after start date
    return data.endDate >= data.startDate;
  }, {
    message: "A befejezés dátuma nem lehet korábban, mint a kezdés dátuma",
    path: ["endDate"]
  });

export type EventFormValues = z.infer<typeof eventFormSchema>;
